import { ComponentStyleConfig } from '@chakra-ui/react';

export const Text: ComponentStyleConfig = {
  baseStyle: {
    color: 'M.70',
    fontWeight: 400,
    lineHeight: 'normal',
    fontSize: 'sm',
    fontVariantNumeric: 'normal',
  },
  sizes: {},
  variants: {},
  defaultProps: {},
};
